import { useEffect } from 'react'

export const useFullName = setDataModal => {
  useEffect(() => {
    setDataModal(null)
  }, [setDataModal])
}
